import { render } from "./intro-banner.vue?vue&type=template&id=db2fe772&ts=true"
import script from "./intro-banner.vue?vue&type=script&lang=ts"
export * from "./intro-banner.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__